import type * as martinez from 'martinez-polygon-clipping'
import { Path } from 'three'
import { ADDITION, type Brush, type Evaluator } from 'three-bvh-csg'

const isPoint = (point: unknown): point is [number, number] => Array.isArray(point) && point.length === 2

export const polygonsToPaths = (features: martinez.Geometry) => {
  const paths: Path[] = []

  for (const feature of features) {
    for (const polygon of feature) {
      const path = new Path()
      const firstPoint = polygon[0]
      if (!isPoint(firstPoint)) {
        continue
      }

      path.moveTo(firstPoint[0], firstPoint[1])
      polygon.slice(1).forEach(point => {
        if (!isPoint(point)) {
          return
        }

        path.lineTo(point[0], point[1])
      })

      path.closePath()
      paths.push(path)
    }
  }

  return paths
}

export const csgCombineMeshes = (csg: Evaluator, meshes: Brush[]) =>
  meshes.reduce((accMesh, featureMesh) => csg.evaluate(accMesh, featureMesh, ADDITION))
